import * as actions from "./actions";

const initialState = {
    items: [],
    pageKey: null,
    loadingItems: false,
    getItemsResult: { success: true },
    // Open items for the inbox badge: { open, openByType }.
    counts: null,
    item: null,
    // Member records by dataObjectId: the record, null when gone, or { readError }.
    itemRecords: {},
    loadingItem: false,
    getItemResult: { success: true },
    lock: null,
    getLockResult: { success: true },
    breakingLock: false,
    breakLockResult: null,
    // A steward's merge or dismiss in progress, and its outcome until it has been shown.
    actingOnItem: false,
    itemActionResult: null,
    // The "Subsumed records" view (PRE-2837), and a steward's retire or restore in progress and its
    // outcome until it has been shown ({ success, action: "retire" | "restore", ... }).
    subsumed: [],
    subsumedPageKey: null,
    loadingSubsumed: false,
    getSubsumedResult: { success: true },
    actingOnSubsumed: false,
    subsumedActionResult: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actions.GET_REVIEW_QUEUE_ITEMS_REQUEST:
            return { ...state, loadingItems: true, ...(action.params.append ? {} : { items: [], pageKey: null }) };
        case actions.GET_REVIEW_QUEUE_ITEMS_SUCCESS: {
            const page = (action.payload && action.payload.items) || [];
            return {
                ...state,
                loadingItems: false,
                items: action.append ? [...state.items, ...page] : page,
                pageKey: (action.payload && action.payload.pageKey) || null,
                getItemsResult: { success: true },
            };
        }
        case actions.GET_REVIEW_QUEUE_ITEMS_FAILURE:
            return { ...state, loadingItems: false, getItemsResult: { success: false, ...action.payload } };
        case actions.GET_REVIEW_QUEUE_COUNTS_SUCCESS:
            return { ...state, counts: action.payload };
        case actions.GET_REVIEW_QUEUE_COUNTS_FAILURE:
            return { ...state, counts: null };
        case actions.GET_REVIEW_QUEUE_ITEM_REQUEST:
            return { ...state, loadingItem: true, item: null, itemRecords: {}, getItemResult: { success: true } };
        case actions.GET_REVIEW_QUEUE_ITEM_SUCCESS:
            return { ...state, loadingItem: false, item: action.payload.item, itemRecords: action.payload.records, getItemResult: { success: true } };
        case actions.GET_REVIEW_QUEUE_ITEM_FAILURE:
            return { ...state, loadingItem: false, getItemResult: { success: false, ...action.payload } };
        case actions.CLEAR_REVIEW_QUEUE_ITEM:
            return { ...state, item: null, itemRecords: {}, loadingItem: false, getItemResult: { success: true } };
        case actions.GET_SCHEMA_JOB_LOCK_SUCCESS:
            return { ...state, lock: action.payload, getLockResult: { success: true } };
        case actions.GET_SCHEMA_JOB_LOCK_FAILURE:
            return { ...state, lock: null, getLockResult: { success: false, ...action.payload } };
        case actions.BREAK_SCHEMA_JOB_LOCK_REQUEST:
            return { ...state, breakingLock: true, breakLockResult: null };
        case actions.BREAK_SCHEMA_JOB_LOCK_SUCCESS:
            return { ...state, breakingLock: false, breakLockResult: { success: true, ...action.payload } };
        case actions.BREAK_SCHEMA_JOB_LOCK_FAILURE:
            return { ...state, breakingLock: false, breakLockResult: { success: false, ...action.payload } };
        case actions.CLEAR_SCHEMA_JOB_LOCK_BREAK_RESULT:
            return { ...state, breakLockResult: null };
        case actions.REVIEW_ITEM_ACTION_REQUEST:
            return { ...state, actingOnItem: true, itemActionResult: null };
        case actions.REVIEW_ITEM_ACTION_SUCCESS: {
            const { item } = action.payload;
            return {
                ...state,
                actingOnItem: false,
                itemActionResult: { success: true, action: action.payload.action },
                item: state.item && item && state.item.itemId === item.itemId ? item : state.item,
                // Shown as it now is until the list is read again.
                items: state.items.map((listed) => (item && listed.itemId === item.itemId ? item : listed)),
            };
        }
        case actions.REVIEW_ITEM_ACTION_FAILURE:
            return { ...state, actingOnItem: false, itemActionResult: { success: false, ...action.payload } };
        case actions.CLEAR_REVIEW_ITEM_ACTION_RESULT:
            return { ...state, itemActionResult: null };
        case actions.GET_SUBSUMED_RECORDS_REQUEST:
            return { ...state, loadingSubsumed: true, getSubsumedResult: { success: true }, ...(action.params.append ? {} : { subsumed: [], subsumedPageKey: null }) };
        case actions.GET_SUBSUMED_RECORDS_SUCCESS: {
            const page = (action.payload && action.payload.items) || [];
            return {
                ...state,
                loadingSubsumed: false,
                subsumed: action.append ? [...state.subsumed, ...page] : page,
                subsumedPageKey: (action.payload && action.payload.pageKey) || null,
                getSubsumedResult: { success: true },
            };
        }
        case actions.GET_SUBSUMED_RECORDS_FAILURE:
            return { ...state, loadingSubsumed: false, getSubsumedResult: { success: false, ...action.payload } };
        case actions.RETIRE_SUBSUMED_REQUEST:
        case actions.RESTORE_SUBSUMED_REQUEST:
            return { ...state, actingOnSubsumed: true, subsumedActionResult: null };
        case actions.RETIRE_SUBSUMED_SUCCESS:
            return { ...state, actingOnSubsumed: false, subsumedActionResult: { success: true, action: "retire", ...action.payload } };
        case actions.RETIRE_SUBSUMED_FAILURE:
            return { ...state, actingOnSubsumed: false, subsumedActionResult: { success: false, action: "retire", ...action.payload } };
        case actions.RESTORE_SUBSUMED_SUCCESS:
            return {
                ...state,
                actingOnSubsumed: false,
                subsumedActionResult: { success: true, action: "restore", ...action.payload },
                // No longer listed once restored.
                subsumed: state.subsumed.filter((entry) => !action.payload || entry.dataObjectId !== action.payload.dataObjectId),
            };
        case actions.RESTORE_SUBSUMED_FAILURE:
            return { ...state, actingOnSubsumed: false, subsumedActionResult: { success: false, action: "restore", ...action.payload } };
        case actions.CLEAR_SUBSUMED_ACTION_RESULT:
            return { ...state, subsumedActionResult: null };
        case actions.RESET_REVIEW_QUEUE:
            // The subsumed view reads its own list (it may already be reading the new schema's).
            return { ...initialState, counts: state.counts, subsumed: state.subsumed, subsumedPageKey: state.subsumedPageKey, loadingSubsumed: state.loadingSubsumed };
        default:
            return state;
    }
};
